import { format } from "date-fns";

export default function shortDateFormat(date: Date) {
  const isThisYear = new Date().getFullYear() === date.getFullYear();
  if (isThisYear) {
    return format(date, "do MMM");
  }
  return format(date, "do MMM yyyy");
}
